var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_5353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5 0C25.297 0 0 25.2882 0 56.5C0 87.7118 25.297 113 56.5 113C87.703 113 113 87.6964 113 56.5C113 25.3036 87.703 0 56.5 0Z",
    fill: "#2AD352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24701e-05 56.4997C-0.0127018 65.8387 2.29993 75.0338 6.72929 83.2556C12.3724 84.9124 18.2239 85.7515 24.1052 85.7473C58.0715 85.7473 85.6064 58.2124 85.6064 24.2462C85.6114 18.2716 84.746 12.3282 83.0374 6.60315C74.8695 2.25248 65.7544 -0.0156992 56.5 -0.000288201C25.297 -0.000288201 5.24701e-05 25.2879 5.24701e-05 56.4997Z",
    fill: "#74DA7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7246 47.1377L54.765 82.8012C53.8395 83.772 52.7276 84.5461 51.4959 85.077C50.2641 85.608 48.9379 85.8848 47.5966 85.891H47.5524C46.2186 85.8914 44.8983 85.6237 43.6699 85.1039C42.4415 84.5841 41.3301 83.8228 40.4016 82.8652L22.3812 64.304C21.4501 63.3694 20.7139 62.2592 20.2154 61.0377C19.7168 59.8163 19.4658 58.508 19.4769 57.1888C19.488 55.8696 19.761 54.5657 20.2801 53.3529C20.7992 52.14 21.554 51.0424 22.5007 50.1236C23.4474 49.2048 24.5672 48.4832 25.795 48.0006C27.0229 47.518 28.3343 47.2842 29.6533 47.3125C30.9722 47.3409 32.2724 47.6309 33.4784 48.1658C34.6843 48.7007 35.772 49.4698 36.6784 50.4284L47.4818 61.5563L74.295 33.399C75.1932 32.4358 76.2735 31.6604 77.4733 31.1174C78.6731 30.5744 79.9687 30.2747 81.2851 30.2356C82.6015 30.1965 83.9126 30.4188 85.1425 30.8896C86.3724 31.3604 87.4968 32.0704 88.4506 32.9786C89.4044 33.8867 90.1687 34.9749 90.6992 36.1803C91.2298 37.3857 91.516 38.6843 91.5415 40.001C91.567 41.3177 91.3312 42.6264 90.8476 43.8514C90.3641 45.0764 89.6425 46.1934 88.7246 47.1377Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_5353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 113,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ae6a564ef726d2e1f5eebca2a5831c40.svg";
export { ForwardRef as ReactComponent };